import React from "react";

const CompliancePolicy = () => {
  return (
    <div className="container my-5">
      <h1>Complaints Procedure</h1>

      <section className="my-5">
        <p>
          Ileero Pay has specific duty to receive and review complaints about
          the services we provide.{" "}
        </p>

        <p>
          We value feedbacks and even complaints, because it gives us an
          opportunity to do better and maintain excellent customer relationship.{" "}
        </p>

        <p>
          We have procedures in place that allow users to complain about the
          services that have been provided to them if they are dissatisfied.{" "}
        </p>
      </section>

      <section className="my-5">
        <h3 className="mb-3">How Ileero Pay handles complaints</h3>
        <p>
          Once we receive your complaint, we will contact you to confirm receipt
          via email within 24 hours of receiving it. Ileero Pay will aim to
          resolve the complaint within three business days.{" "}
        </p>
        <p>
          On occasion, a complaint may need to be escalated further, our
          customer service team may extend the timeline to resolve the complaint
          by the end of 15 business days following receipt of the complaint.{" "}
        </p>
        <p>
          If we need more than 15 days to resolve your complaint, we will
          contact you weekly to provide an update on the progress of our
          investigation.{" "}
        </p>

        <p>
          If due to exceptional circumstances we are unable to issue a final
          response within 15 business days, we have up to a maximum 35 business
          days from the date of receipt to issue a final response.
        </p>
        <p>
          Once all the details of the complaint have been investigated, we will
          issue a final response to your complaint.
        </p>
      </section>

      <section className="my-5">
        <h3 className="mb-3">
          What information do I need to provide when making compliant
        </h3>
        <p>
          When making a complaint, please outline the following information:{" "}
        </p>
        <ul>
          <li>The date of the complaint </li>
          <li>The nature of your complaint</li>
          <li>The impact on your business </li>
          <li>Phone number and best time to contact you</li>
          <li>Any actions you wish us to take to resolve your complaint</li>
          <li>Any additional information </li>
        </ul>
      </section>

      <section className="my-5">
        <h3 className="mb-3">How do I make complaints </h3>
        <p>Ileero Pay Complaint Support Channel:</p>
        <p>
          By email:{" "}
          <a href="mailto:customercare@ileero.com">customercare@ileero.com</a>
        </p>
        <p>
          By phone: <a href="tel:+442030112409">+44 20 3011 2409</a> |{" "}
          <a href="tel:+448002545064">+44 800 254 5064</a>
        </p>
        <p>Via Ileero Remit website: chatbot</p>
        <p>By post: Ileero Pay Limited, No 33 Mountview House, 202-212 High Rd, Ilford IG1 1QB</p>
      </section>

      <section className="my-5">
        <h3 className="mb-3">If I am unhappy with the resolution</h3>
        <p>
          If you are not happy with our resolution you can refer your complaint
          to the{" "}
          <span className="font-weight-bold">Financial Ombudsman Service</span>.{" "}
          <span className="font-weight-bold">Click here</span>{" "}
          <a
            href="http://www.financial-ombudsman.org.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.financial-ombudsman.org.uk
          </a>
        </p>

        <p>Tel: 0800 023 4567 | 0300 123 9123 | 44 20 7964 0500 </p>
        <p>
          Email:{" "}
          <a href="mailto:complaint.info@financial-ombudsman.org.uk">
            complaint.info@financial-ombudsman.org.uk
          </a>
        </p>
        <p>
          Website:{" "}
          <a
            href="http://www.financial-ombudsman.org.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.financial-ombudsman.org.uk
          </a>
        </p>
        <p>
          Address: The Financial Ombudsman Service, Exchange Tower, London E14
          9SR{" "}
        </p>
        <p>Financial Ombudsman Service consider a complainant if you are: </p>
        <ul>
          <li>A consumer </li>
          <li>
            A micro enterprise (enterprise which employs fewer than 10 people
            and has a turnover or balance sheets that does not exceed EUR
            2,000,000){" "}
          </li>
          <li>A charity with an annual income of less than £6,500,000 </li>
          <li>
            A trustee of a trust which has a net asset value of less than
            £5,000,000{" "}
          </li>
          <li>
            A small business (enterprise that is not a micro enterprise, has an
            annual turnover of less than £6,500,000 and employs fewer than 50
            people or has a balance sheet total of less than £5,000,000){" "}
          </li>
        </ul>

        <p>
          Ileero Pay will co-operate fully with the Financial Ombudsman Service
          in resolving any complaints made against it.{" "}
        </p>
      </section>
    </div>
  );
};

export default CompliancePolicy;
